<template>

  <div class="common-seach-wrap">
    <el-tabs v-model="bannerName">
      <el-tab-pane label="广告位管理" name="first"></el-tab-pane>
    </el-tabs>

    
    <AD v-if="bannerName == 'first'"></AD>
  </div>
</template>
<script>
import AD from './ad/index';
export default {
  components: {
    AD
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      bannerName: 'first'
    };
  },
  methods: {}
};
</script>

<style>
.operation-wrap {
  height: 124px;
  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 30px 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background: #909399;
  background-size: 100% 100%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ad/index.vue